<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<div fxLayout="row" fxLayoutGap="16px">
  <div
    class="employee-filter"
    fxLayout="row"
    fxLayoutGap="16px"
    fxLayoutAlign="start center"
  >
    <div fxFlex="100px">
      <app-chips-autocomplete
        [title]="executedByText"
        [inputPlaceholder]="selectEmployeesPlaceholder"
        [allElements]="availableEmployees"
        (selectionchange)="onEmployeeSelectionChange($event)"
        [value]="selectedEmployeeIds"
        subscriptSizing="dynamic"
      >
      </app-chips-autocomplete>
    </div>
  </div>
  <div class="expand"></div>
  <div>
    <app-date-range-picker
      [dateFilterValue]="dateFilterValue"
      (dateFilterChange)="onDateFilterChange($event)"
    ></app-date-range-picker>
  </div>
</div>
